module.exports = __webpack_public_path__ + "static/img/team7.2b7b316.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructors/team7.jpg
// module id = 3Tq9
// module chunks = 1